export default __webpack_public_path__ + "assets/images/7698d8b8c73635188bef2b341b4e3c9b.png";